module.exports = __webpack_public_path__ + "img/orange.5d5330ca.png";